import { useRef, useState } from "react";
import { ChevronsLeftRight } from "lucide-react";

const isVideo = (src) => typeof src === "string" && (src.endsWith(".mp4") || src.endsWith(".webm"));

export function VorherNachher({ before, after, altBefore, altAfter, testid }) {
  const ref = useRef(null);
  const [pos, setPos] = useState(50);

  function update(clientX) {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    const p = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.min(96, Math.max(4, p)));
  }

  return (
    <div
      ref={ref}
      data-testid={testid}
      role="slider"
      aria-label="Vorher-Nachher-Vergleich verschieben"
      aria-valuenow={Math.round(pos)}
      aria-valuemin={0}
      aria-valuemax={100}
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "ArrowLeft") setPos((p) => Math.max(4, p - 5));
        if (e.key === "ArrowRight") setPos((p) => Math.min(96, p + 5));
      }}
      onPointerDown={(e) => {
        ref.current.setPointerCapture(e.pointerId);
        update(e.clientX);
      }}
      onPointerMove={(e) => e.buttons === 1 && update(e.clientX)}
      className="relative aspect-[3/4] overflow-hidden border border-[#24211D]/10 select-none touch-none cursor-ew-resize bg-[#F4EFE6]"
    >
      {isVideo(after) ? (
        <video src={after} aria-label={altAfter} autoPlay muted loop playsInline className="absolute inset-0 w-full h-full object-cover" />
      ) : (
        <img src={after} alt={altAfter} className="absolute inset-0 w-full h-full object-cover" draggable={false} />
      )}
      {isVideo(before) ? (
        <video
          src={before}
          aria-label={altBefore}
          autoPlay
          muted
          loop
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
          style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}
        />
      ) : (
        <img
          src={before}
          alt={altBefore}
          className="absolute inset-0 w-full h-full object-cover"
          style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}
          draggable={false}
        />
      )}
      <span className="absolute top-3 left-3 text-[10px] uppercase tracking-[0.18em] font-sans text-[#FBF8F3] bg-[#24211D]/60 px-2.5 py-1">Vorher</span>
      <span className="absolute top-3 right-3 text-[10px] uppercase tracking-[0.18em] font-sans text-[#24211D] bg-[#FBF8F3]/85 px-2.5 py-1">Nachher</span>
      <div className="absolute inset-y-0 pointer-events-none" style={{ left: `${pos}%` }}>
        <div className="absolute inset-y-0 -left-px w-0.5 bg-[#FBF8F3] shadow" />
        <div className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-10 h-10 rounded-full bg-[#B08D57] text-[#FBF8F3] flex items-center justify-center shadow-lg">
          <ChevronsLeftRight size={18} />
        </div>
      </div>
    </div>
  );
}
